export default "__VITE_ASSET__CYtzS$tL__"